import { useContext } from "react";
import { AbilityContext } from "@/contexts/AbilityContext";
import type { AppAbility } from "@/lib/casl/types";

export function useAbility(): AppAbility {
	return useContext(AbilityContext);
}
